"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detachAssignedRepaymentTapeArtifacts = exports.attachAssignedRepaymentTapeArtifacts = void 0;
const common_1 = require("@finley-technologies/common");
const dbNodes = __importStar(require("../dbNodes/dbNodes"));
const utils = __importStar(require("../dbNodes/utils"));
const cloneDeep_1 = __importDefault(require("lodash/fp/cloneDeep"));
// This is safe since LP & CF are an unique combo
const _findAssignedLoanTapeByLpAndCf = (params) => {
    const { creditFacilitySlug, dataTapes, loanProductSlug } = params;
    const assignedLoanTapes = dataTapes
        .filter(dbNodes.assignedLoanTape.isNode)
        .filter((tape) => tape.loanProductSlug === loanProductSlug &&
        tape.creditFacilitySlug === creditFacilitySlug);
    (0, common_1.finleyAssert)(assignedLoanTapes.length === 1, `Assigned Repayment Tape Synthetic: Expected 1 but found ${assignedLoanTapes.length} assignedLoanTapes [cfSlug:${creditFacilitySlug}] [lpSlug:${loanProductSlug}]`);
    return assignedLoanTapes[0];
};
/**
 * "AssignedRepaymentTape" is already a UI node that's present in the graph so no need to create
 * any new nodes. Will need to manage new dependencies and update "assigned repayment tape" configuration
 *
 *                        *** Current ***
 * +-----------------------+            +-----------------------+
 * | InternalRepaymentTape | ---------> | AssignedRepaymentTape |
 * +-----------------------+            +-----------------------+
 *
 *                        *** Revised ***
 * +-----------------------+            +-----------------------+
 * | InternalRepaymentTape | ---------> | AssignedRepaymentTape |
 * +-----------------------+            +-----------------------+
 *                                         ^    ^
 * +-----------------------+               |    |
 * |    AssignedLoanTape   | --------------+    |
 * +-----------------------+                    |
 *                                              |
 * +------------------------+                   |
 * | GeneratedRepaymentTape | ------------------+
 * +------------------------+
 *
 * "AssignedLoanTape" needs to already be completed so "AssignedRepaymentTape" can safely utilize the
 * assignments set in the loan tape
 */
const attachAssignedRepaymentTapeArtifacts = (dbGraph) => {
    const assignedRepaymentTapes = utils.filterAssignedRepaymentTapes({
        dataTapes: dbGraph.dataTapes,
    });
    if (assignedRepaymentTapes.length === 0) {
        return dbGraph;
    }
    const clonedDbGraph = (0, cloneDeep_1.default)(dbGraph);
    const { dataTapes, dataTapeDependencies } = clonedDbGraph;
    for (const assignedRepaymentTape of assignedRepaymentTapes) {
        const { loanProductSlug, creditFacilitySlug } = assignedRepaymentTape;
        // *** Fetch Needed Tapes ***
        // Recall that this occurs after "internal repayment tape" synthetic process,
        // so that input dependency has already been set
        const assignedRepaymentInputTapes = utils.getInputTapes({
            dbGraph: clonedDbGraph,
            outputArtifactId: assignedRepaymentTape.id,
        });
        const internalRepaymentTapes = utils.filterInternalRepaymentTapes({
            dataTapes: assignedRepaymentInputTapes,
        });
        (0, common_1.finleyAssert)(internalRepaymentTapes.length === 1, `Assigned Repayment Tape Attach Synthetic: Expected 1 but found ${internalRepaymentTapes.length} internalRepaymentTape`);
        const internalRepaymentTape = internalRepaymentTapes[0];
        const internalRepaymentInputs = utils.getInputTapes({
            dbGraph: clonedDbGraph,
            outputArtifactId: internalRepaymentTape.id,
        });
        const generatedRepaymentTapes = utils.filterGeneratedRepaymentTapes({
            dataTapes: internalRepaymentInputs,
        });
        (0, common_1.finleyAssert)(generatedRepaymentTapes.length === 1, `Assigned Repayment Tape Attach Synthetic: Expected 1 but found ${generatedRepaymentTapes.length} generatedRepaymentTape`);
        const generatedRepaymentTape = generatedRepaymentTapes[0];
        const assignedLoanTape = _findAssignedLoanTapeByLpAndCf({
            dataTapes,
            creditFacilitySlug,
            loanProductSlug,
        });
        // *** Update Dependencies ***
        // Add new input: "generated repayment tape" --> "assigned repayment tape"
        dataTapeDependencies.push({
            inputArtifactId: generatedRepaymentTape.id,
            outputArtifactId: assignedRepaymentTape.id,
        });
        // Add new input: "assigned loan tape" --> "assigned repayment tape"
        dataTapeDependencies.push({
            inputArtifactId: assignedLoanTape.id,
            outputArtifactId: assignedRepaymentTape.id,
        });
        // *** Update Data Tapes ***
        // Update configuration to point to synthetic input artifacts
        const updatedAssignedRepaymentTape = {
            ...assignedRepaymentTape,
            configuration: {
                generatedRepaymentTapeArtifactSlug: generatedRepaymentTape.artifactSlug,
                internalRepaymentTapeArtifactSlug: internalRepaymentTape.artifactSlug,
                assignedLoanTapeArtifactSlug: assignedLoanTape.artifactSlug,
            },
        };
        const assignedRepaymentIdx = dataTapes.findIndex((tape) => tape.id === assignedRepaymentTape.id);
        dataTapes[assignedRepaymentIdx] = updatedAssignedRepaymentTape;
    }
    return { dataTapeDependencies, dataTapes };
};
exports.attachAssignedRepaymentTapeArtifacts = attachAssignedRepaymentTapeArtifacts;
/**
 * Detachment process for "AssignedRepaymentTape" would just be to detach
 * synthetic input dependencies and update configuration.
 *
 *                        *** Current ***
 * +-----------------------+            +-----------------------+
 * | InternalRepaymentTape | ---------> | AssignedRepaymentTape |
 * +-----------------------+            +-----------------------+
 *                                         ^    ^
 * +-----------------------+               |    |
 * |    AssignedLoanTape   | --------------+    |
 * +-----------------------+                    |
 *                                              |
 * +------------------------+                   |
 * | GeneratedRepaymentTape | ------------------+
 * +------------------------+
 *
 *                        *** Revised ***
 * +-----------------------+            +-----------------------+
 * | InternalRepaymentTape | ---------> | AssignedRepaymentTape |
 * +-----------------------+            +-----------------------+
 */
const detachAssignedRepaymentTapeArtifacts = (dbGraph) => {
    const assignedRepaymentTapes = utils.filterSyntheticAssignedRepaymentTapes({
        dataTapes: dbGraph.dataTapes,
    });
    if (assignedRepaymentTapes.length === 0) {
        return dbGraph;
    }
    const clonedDbGraph = (0, cloneDeep_1.default)(dbGraph);
    const { dataTapes } = clonedDbGraph;
    let { dataTapeDependencies } = clonedDbGraph;
    for (const assignedRepaymentTape of assignedRepaymentTapes) {
        const { loanProductSlug, creditFacilitySlug } = assignedRepaymentTape;
        // *** Update Dependencies ***
        const assignedRepaymentTapeInputs = utils.getInputTapes({
            dbGraph: clonedDbGraph,
            outputArtifactId: assignedRepaymentTape.id,
        });
        // Expecting "GeneratedRepaymentTape", "InternalRepaymentTape", and "AssignedLoanTape" as inputs
        (0, common_1.finleyAssert)(assignedRepaymentTapeInputs.length === 3, `Assigned Repayment Tape Detach Synthetic: Expected 3 input dependencies for AssignedRepaymentTape, found [${assignedRepaymentTapeInputs.length}]`);
        const internalRepaymentTapes = utils.filterInternalRepaymentTapes({
            dataTapes: assignedRepaymentTapeInputs,
        });
        (0, common_1.finleyAssert)(internalRepaymentTapes.length === 1, `Assigned Repayment Tape Detach Synthetic: Expected 1 but found ${internalRepaymentTapes.length} internalRepaymentTape`);
        const internalRepaymentTape = internalRepaymentTapes[0];
        const internalRepaymentInputs = utils.getInputTapes({
            dbGraph: clonedDbGraph,
            outputArtifactId: internalRepaymentTape.id,
        });
        const generatedRepaymentTapes = utils.filterGeneratedRepaymentTapes({
            dataTapes: internalRepaymentInputs,
        });
        (0, common_1.finleyAssert)(generatedRepaymentTapes.length === 1, `Assigned Repayment Tape Detach Synthetic: Expected 1 but found ${generatedRepaymentTapes.length} generatedRepaymentTape`);
        // Remove "GeneratedRepaymentTape" as an input
        // Weirdly enough this is actually an input dependency to "AssignedRepaymentTape",
        // but this will be reconnected during "InternalRepaymentTape" synthetic process
        const generatedRepaymentTape = generatedRepaymentTapes[0];
        dataTapeDependencies = utils.removeDependency({
            dataTapeDependencies,
            dependencyToRemove: {
                inputArtifactId: generatedRepaymentTape.id,
                outputArtifactId: assignedRepaymentTape.id,
            },
        });
        // Remove "AssignedLoanTape" as an input
        const assignedLoanTapeInput = _findAssignedLoanTapeByLpAndCf({
            dataTapes: assignedRepaymentTapeInputs,
            creditFacilitySlug,
            loanProductSlug,
        });
        dataTapeDependencies = utils.removeDependency({
            dataTapeDependencies,
            dependencyToRemove: {
                inputArtifactId: assignedLoanTapeInput.id,
                outputArtifactId: assignedRepaymentTape.id,
            },
        });
        // *** Update Data Tapes ***
        // Update configuration to remove synthetic artifact relations
        const { generatedRepaymentTapeArtifactSlug: _unused1, internalRepaymentTapeArtifactSlug: _unused2, assignedLoanTapeArtifactSlug: _unused3, ...remainingConfig } = assignedRepaymentTape.configuration;
        const updatedAssignedRepaymentTape = {
            ...assignedRepaymentTape,
            configuration: remainingConfig,
        };
        const assignedRepaymentIdx = dataTapes.findIndex((tape) => tape.id === assignedRepaymentTape.id);
        dataTapes[assignedRepaymentIdx] = updatedAssignedRepaymentTape;
    }
    return { dataTapeDependencies, dataTapes };
};
exports.detachAssignedRepaymentTapeArtifacts = detachAssignedRepaymentTapeArtifacts;
//# sourceMappingURL=assignedRepaymentTape.js.map